import {emptyValue} from "./global";

function getTranslatedCustomerSegment(customer_segment){
    if(customer_segment === 'standard') return 'Standard';
    else if(customer_segment === 'premium') return 'Premium';
    else if(customer_segment === 'WIWI') return 'WIWI';
    else return emptyValue;
}

export default getTranslatedCustomerSegment;